import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from './box';
import Heading from './headings';
import Input from './input';
import Button from './button';
import Container from './container';
import config from '../../config-dev';
import EmailLink from './emaillink';

const ContactUSWrapper = styled.section`
  padding: 80px 0;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 40px 0 60px 0;
  }
`;

const ContactUsForm = styled.div`
  align-items: left;
  justify-content: space-between;
  max-width: 488px;
  margin: 0 auto;
  @media (max-width: 575px) {
    flex-direction: column;
    max-width: 100%;
  }
  .reusecore__input {
    margin-bottom: 10px;
    &.is-material {
      &.is-focus {
        label {
          color: rgb(26, 115, 232);
          top: -3px;
        }
        .highlight {
          background-color: rgb(26, 115, 232);
        }
      }
      textarea {
        min-height: 100px;
      }
    }
    label {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      top: 20px;
    }
  }
  .reusecore__button {
    flex-shrink: 0;
    transition: all 0.3s ease;
    @media (max-width: 575px) {
      width: 100%;
    }
    &:hover {
      box-shadow: 0px 9px 20px -5px rgba(16, 172, 132, 0.57);
    }
  }
  .invalid-feedback {
    font-weight: 600;
    font-size: 12px;
    color: rgba(255, 0, 0, 0.6);
    margin-bottom: 5px;
  }
  .valid-feedback {
    margin-top: 5px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    min-height: 20px;
  }
`;


class ContactUsSection extends React.Component {

    initialState = {
      email: '',
      firstname: '',
      lastname: '',
      description: '',
      emailError: '',
      firstnameError: '',
      lastnameError: '',
      emailValid: '',
      firstnameValid: '',
      lastnameValid: '',
      formValid: '',
      messageSentResponse: ''
    }

    constructor (props) {
      super(props);
      this.state = this.initialState;
    }

    clearMessageSentStatus = () => {
      this.setState({ messageSentResponse: ''});
    }

    validateLastname = () => {
      const {lastname} = this.state;
      this.setState({ lastnameValid: lastname.length>0});
      this.setState({ lastnameError: this.state.lastnameValid ? '': 'Please enter lastname!'});
    }

    validateFirstname = () => {
      const {firstname} = this.state;
      this.setState({ firstnameValid: firstname.length>0});
      this.setState({ firstnameError: this.state.firstnameValid ? '': 'Please enter firstname!'});
    }

    validateEmail = () => {
      const {email} = this.state;
      this.setState({ emailValid:  email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)});
      this.setState({ emailError: this.state.emailValid ? '': 'Please enter valid email!'});
    }

    handleUserInput = (evt) => {
      this.clearMessageSentStatus();
      const name = evt.target.name;
      const value = evt.target.value;
      this.setState({[name]: value},
                    () => { this.validateField(name, value) });
    }

    validateField = (fieldname, value) => {
        switch (fieldname) {
            case 'email':
                this.validateEmail();
                break;
            case 'lastname':
                this.validateLastname();
                break;
            case 'firstname':
                this.validateFirstname();
                break;
            default:
              break;
        }
    }

    validateForm() {
      return this.state.firstnameValid && this.state.lastnameValid && this.state.emailValid;
    }

    formReset = () => {
      this.setState(() => this.initialState);
    }

    sendContactForm = (evt) => {
       evt.preventDefault();
       if (this.validateForm())
       {
         const messageData = {
            email: this.state.email,
            lastname: this.state.lastname,
            firstname: this.state.firstname,
            description: this.state.description
            };
         console.log("DATA: ", messageData);

         fetch(config.submitContactFormURL, {
           method: "POST",
           mode: "cors",
           headers: {"Content-Type": "application/json"},
           body: JSON.stringify(messageData)
         })
         .then(response=>response.json())
         .then(response=> {
           console.log("Success: ", response);
           this.setState({messageSentResponse:response.message})
         })
         .catch(error=> console.error("ERROR: ", error))
         this.formReset();
       }
       else {
         this.validateFirstname();
         this.validateLastname();
         this.validateEmail();
       }
    };

    render() {
      return (
        <ContactUSWrapper id="contactus">
          <Container>
            <Box {...this.props.sectionHeader}>
              <Heading content="Contact Us" {...this.props.sectionTitle} />
              <Heading
                content="Please send us an email with a brief description of your business needs and we will be in touch"
                {...this.props.sectionSubTitle}
              />
              <EmailLink
                email="info@89clouds.com"
                subject="Message from 89clouds.com"
                iconPosition="left"
              />
            </Box>
            <Box>
              <ContactUsForm>
                <div className='invalid-feedback'>{this.state.firstnameError}</div>
                <Input
                  inputType="text"
                  isMaterial label ="Firstname"
                  htmlFor="firstname"
                  value={this.state.firstname}
                  onChange={this.handleUserInput}
                  onBlur={this.handleUserInput}
                />
                <div className='invalid-feedback'>{this.state.lastnameError}</div>
                <Input
                  inputType="text"
                  isMaterial label="Lastname"
                  htmlFor="lastname"
                  value={this.state.lastname}
                  onChange={this.handleUserInput}
                  onBlur={this.handleUserInput}
                />
                <div className='invalid-feedback'>{this.state.emailError}</div>
                <Input
                  inputType="email"
                  isMaterial label="Email"
                  htmlFor="email"
                  value={this.state.email}
                  onChange={this.handleUserInput}
                  onBlur={this.handleUserInput}
                />
                <Input
                  inputType="textarea"
                  isMaterial label ="Description"
                  htmlFor="description"
                  value={this.state.description}
                  onChange={this.handleUserInput}
                  onBlur={this.handleUserInput}
                />
                <Button type="button" title="SEND" onClick = {this.sendContactForm} {...this.props.btnStyle} />
                <div className='valid-feedback'>{this.state.messageSentResponse}</div>
              </ContactUsForm>
            </Box>
          </Container>
        </ContactUSWrapper>
      );
    }
};

// ContactUsSection style props
ContactUsSection.propTypes = {
  sectionHeader: PropTypes.object,
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
};

// ContactUsSection default style
ContactUsSection.defaultProps = {
  // section header default style
  sectionHeader: {
    mb: '56px',
  },
  // section title default style
  sectionTitle: {
    textAlign: 'center',
    fontSize: ['20px', '24px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '0',
  },
  // button default style
  btnStyle: {
    minWidth: '152px',
    minHeight: '45px',
    fontSize: '14px',
    fontWeight: '500',
  },
  sectionSubTitle: {
    padding: '20px 0',
    fontSize: '16px',
    fontWeight: '400',
    color: '#343d48',
    lineHeight: '1.5',
    textAlign: 'center',
    mb: '8px',
    letterSpacing: '-0.020em',
  },

};

export default ContactUsSection;
